<template>
  <div class="pc-tips-section" v-if="showTips">
    <bap-collapse label-align="end">
      <template v-slot:label>
        <div style="gap: 16px; align-items: end; display: flex">
          <a v-if="goBackUrl" @click.stop="" :href="goBackUrl">
            <i class="fa fa-arrow-left"></i> Go Back
          </a>
          <h2 style="margin: 0">Help</h2>
        </div>
      </template>
      <div>
        <p>
          A JSON Priceable event is expected in the "Event" text area.
          <br />
          Formulas can be found
          <a target="_blank" href="/manage/resources/pricing-formulas">here</a>.
          <br />
          Contact BAP Team for assistance at
          <a target="_blank" href="https://redventures.slack.com/archives/C844VG546">#bap-dev</a>
        </p>
      </div>
    </bap-collapse>
  </div>
</template>

<script>
export default {
  name: "FormulaTips",
  props: {
    goBackUrl: {
      default: null,
      require: false,
    },
  },
  data() {
    return {
      showTips: true,
    };
  },
};
</script>
